import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatTab, MatTabContent, MatTabGroup } from '@angular/material/tabs'
import { ElderTabDirective, ElderSinglePaneWrapperComponent } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { PackageTypeBrowserComponent } from '../../storage/packages/type/package-type-browser/package-type-browser.component'

@Component({
  selector: 'app-settings-manager',
  templateUrl: './settings-manager.component.html',
  styleUrls: ['./settings-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatTabGroup,
    MatTab,
    ElderTabDirective,
    MatTabContent,
    PackageTypeBrowserComponent,
    ElderTranslatePipe,
    ElderSinglePaneWrapperComponent,
  ],
})
export class SettingsManagerComponent {}
